module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "py-8"
  }, [_c('div', {
    staticClass: "pb-6 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "size": 130,
      "width": 15,
      "value": _vm.progressUploadPresentation,
      "color": "#2690cb"
    }
  }, [_c('span', {
    staticClass: "font-weight-500 black60--text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.liveClassTotalCheckRow) + "/" + _vm._s(_vm.liveClassTotal || 0) + "\n                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500 black--text text-center",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n            Mohon menunggu, data sedang di proses\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ceec357","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/DialogUploadProgress.vue
// module id = 1677
// module chunks = 1